// Export array list of holidays.
export const extraHolidays: Array<any> = [
//   { date: "2022-11-22 00:00:00" },
//   { date: "2022-11-21 00:00:00" },
];
